import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isToday from 'dayjs/plugin/isToday';
import duration from 'dayjs/plugin/duration';

dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isToday);
dayjs.extend(duration);

const formatDuration = (seconds, t) => {
  if (!seconds || seconds === 0) return '-';

  const duration = dayjs.duration(seconds, 'seconds');
  // Convert days to hours and add to existing hours
  const totalHours = Math.floor(duration.asDays()) * 24 + duration.hours();
  const minutes = duration.minutes();
  const remainingSeconds = duration.seconds();

  const parts = [];
  const hasHourOrMore = totalHours > 0;

  if (totalHours > 0) {
    parts.push(t('common.time.hours', { count: totalHours }));
  }
  if (minutes > 0) {
    parts.push(t('common.time.minutes', { count: minutes }));
  }
  if (!hasHourOrMore && (remainingSeconds > 0 || parts.length === 0)) {
    parts.push(t('common.time.seconds', { count: remainingSeconds }));
  }

  return parts.join(' ');
};


const DayjsPlugin = {
  install(app) {
    app.config.globalProperties.$dayjs = dayjs;
    app.config.globalProperties.$dayjsFormatMetricDuration = formatDuration;
  },
};

export { dayjs };
export default DayjsPlugin;
